import React from 'react';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import {
  Box,
  Button,
  Grid,
  IconButton,
  TextField,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useTranslate } from 'react-admin';
import type { NotificationTestFormValues } from '../../types/notificationTest';

export const VariablesArray: React.FC = () => {
  const translate = useTranslate();
  const { control } = useFormContext<NotificationTestFormValues>();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'message.variables',
  });

  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'primary.light',
        borderRadius: 1,
        p: 2,
        mb: 2,
      }}
    >
      <Button
        variant="contained"
        onClick={() => append({ key: '', value: '' })}
        sx={{
          textTransform: 'none',
          mb: 2,
          width: { xs: '100%', sm: 'auto' },
        }}
      >
        {translate('resources.test.actions.addVariable')}
      </Button>
      <Grid container spacing={{ xs: 1.5, sm: 2 }}>
        {fields.map((f, i) => (
          <React.Fragment key={f.id}>
            <Grid item xs={12} md={5}>
              <Controller
                name={`message.variables.${i}.key` as const}
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    placeholder={translate('resources.test.fields.variableKey')}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <Controller
                name={`message.variables.${i}.value` as const}
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    placeholder={translate(
                      'resources.test.fields.variableValue'
                    )}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <IconButton
                onClick={() => remove(i)}
                sx={{ border: 1, borderColor: 'divider' }}
                aria-label="remove variable"
              >
                <CloseIcon color="error" />
              </IconButton>
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </Box>
  );
};

export default VariablesArray;
